import { Component } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

class SafeMarkdown extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Markdown rendering error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Fallback UI when markdown fails
      return (
        <div style={{ 
          whiteSpace: 'pre-wrap', 
          lineHeight: '1.6',
          padding: '12px',
          background: '#f9f9f9',
          borderRadius: '4px',
          border: '1px solid #e0e0e0'
        }}>
          {this.props.children}
        </div>
      );
    }

    const { children, components, ...otherProps } = this.props;
    
    // Sanitize content before rendering
    const sanitizedContent = typeof children === 'string' 
      ? children
          .replace(/\|(?![^`]*`[^`]*`)/g, '\\|') // Escape pipes outside code blocks
          .replace(/^\s*\|.*\|.*$/gm, (match) => {
            // Convert problematic table rows to code blocks
            return '```\n' + match.replace(/\\\|/g, '|') + '\n```';
          })
      : children;

    return (
      <ReactMarkdown 
        remarkPlugins={[remarkGfm]}
        components={components}
        skipHtml={true}
        {...otherProps}
      >
        {sanitizedContent}
      </ReactMarkdown>
    );
  }
}

export default SafeMarkdown;